import { render, staticRenderFns } from "./slider-note-form.vue?vue&type=template&id=2543704c&"
import script from "./slider-note-form.vue?vue&type=script&lang=js&"
export * from "./slider-note-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports